/**
 * PDP live free-shipping progress: cart.total (post-discount) + selected pack/qty line.
 * Cart/drawer rely on Liquid morph via Section Rendering; this script is for data-live hosts.
 */
(() => {
  const THRESHOLD_FALLBACK = 30000;

  const formatHkd = (cents) => {
    const n = Math.max(0, Number(cents) || 0) / 100;
    return `HK$${n.toLocaleString('en-HK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const messageFor = (lang, remaining, met) => {
    if (lang === 'en') {
      return met
        ? 'Free shipping unlocked (HK$300 threshold met · SF Express)'
        : `Spend ${formatHkd(remaining)} more for free shipping`;
    }
    return met
      ? '已享免運（滿 HK$300 · 順豐）'
      : `再買 ${formatHkd(remaining)} 即享免運`;
  };

  const lineCentsFromPack = (root) => {
    const pack = root.closest('product-form-component')?.querySelector('vow-pack-options')
      || document.querySelector('vow-pack-options');
    const form = root.closest('form') || pack?.closest('form') || document.querySelector('form[data-type="add-to-cart-form"]');
    const qtyInput = form?.querySelector('input[name="quantity"]');
    const quantity = Math.max(0, Number(qtyInput?.value) || 0);

    if (pack instanceof HTMLElement && pack.dataset.unitPrice) {
      const unit = Number(pack.dataset.unitPrice) || 0;
      const discountUnit = Number(pack.dataset.discountPrice) || unit;
      const threshold = Number(pack.dataset.discountThreshold) || Infinity;
      const unitPrice = quantity >= threshold ? discountUnit : unit;
      return unitPrice * quantity;
    }

    // Non-pack PDP: use selected variant price * qty when available
    const priceEl = document.querySelector('[data-product-price], .price__current, product-price');
    const centsAttr = form?.querySelector('[name="id"]')?.dataset?.price;
    if (centsAttr) return Number(centsAttr) * Math.max(1, quantity || 1);
    return 0;
  };

  const apply = (el, effectiveCents) => {
    const threshold = Number(el.dataset.threshold) || THRESHOLD_FALLBACK;
    const lang = el.dataset.lang || 'zh';
    const remaining = Math.max(0, threshold - effectiveCents);
    const met = effectiveCents >= threshold;
    const pct = Math.max(0, Math.min(100, (effectiveCents / threshold) * 100));

    el.classList.toggle('vow-free-shipping--met', met);
    const msg = el.querySelector('[data-vow-fs-message]');
    if (msg) msg.textContent = messageFor(lang, remaining, met);
    const bar = el.querySelector('[data-vow-fs-bar]');
    if (bar) bar.style.width = `${pct}%`;
    const track = el.querySelector('[data-vow-fs-track]');
    if (track) {
      track.setAttribute('aria-valuenow', String(Math.round(pct)));
      track.querySelector('.vow-free-shipping__icon');
    }
    const icon = el.querySelector('.vow-free-shipping__icon');
    if (icon) icon.textContent = met ? '✓' : '🚚';
  };

  const refreshHost = async (el) => {
    let cartTotal = Number(el.dataset.cartTotal) || 0;
    try {
      const res = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.json`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (res.ok) {
        const cart = await res.json();
        // total_price is post-discount
        cartTotal = Number(cart.total_price) || 0;
        el.dataset.cartTotal = String(cartTotal);
      }
    } catch (_) {
      /* keep liquid cart total */
    }

    const project = el.dataset.live === 'true';
    const addCents = project ? lineCentsFromPack(el) : 0;
    apply(el, cartTotal + addCents);
  };

  const refreshAll = () => {
    document.querySelectorAll('[data-vow-free-shipping][data-live="true"]').forEach((el) => {
      refreshHost(el);
    });
  };

  const bind = () => {
    refreshAll();
    document.addEventListener('change', (event) => {
      const t = event.target;
      if (!(t instanceof HTMLElement)) return;
      if (t.matches('input[type="radio"][name^="vow-pack"], input[name="quantity"]')) {
        refreshAll();
      }
    });
    document.addEventListener('input', (event) => {
      const t = event.target;
      if (t instanceof HTMLInputElement && t.name === 'quantity') refreshAll();
    });
    // Horizon / Shopify cart events when present
    document.addEventListener('cart:update', refreshAll);
    document.addEventListener('cart-update', refreshAll);
    if (window.Theme?.events) {
      /* no-op guard */
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  // Re-run after pack options finish initializing (they set quantity)
  customElements.whenDefined('vow-pack-options').then(() => {
    setTimeout(refreshAll, 50);
    setTimeout(refreshAll, 300);
  }).catch(() => {});
})();
